/** Match the qualified procedure labels used by the catalog timeline. */
export function qualifiedProcedureTitle(title: string, qualifier?: string): string {
  return [title, qualifier?.trim()].filter(Boolean).join(" · ");
}
